// only dependency free environment variables
import { gameVariants } from "./utils/gameVariants";

export const isMobile: boolean = /Mobi|Android/i.test(navigator.userAgent);

/**
 * Full gameName read from URL
 * I.e. Raiders_of_the_North_web
 */
export const gameID = getGameIDFromQueryFull();

/**
 * gameName from URL without game variant (_web, _mobile etc.)
 * I.e. Raiders_of_the_North
 */
export const gameIDShort = getGameIDFromQuery();

export const isMachine: boolean = gameID.indexOf("_machine") > -1 || gameID.indexOf("_es_premium") > -1;
export const isPrerenderCrawler = navigator?.userAgent?.indexOf("https://github.com/prerender/prerender") > -1 || navigator?.userAgent === "Prerender";

export const runningInIframe = window.top !== window.self;

export function getBuildTimestamp(): number {
	if (typeof (_BUILD_TIMESTAMP) !== "undefined") {
		return _BUILD_TIMESTAMP;
	} else {
		return 0;
	}
}

export function getGameIDFromQueryFull(): string {
	const params = new URLSearchParams(window.location.search);
	return params.get("gameName") ?? "not-set";
}

/**
 * Returns gameName from URL without game variant (_web, _mobile etc.)
 */
export function getGameIDFromQuery(): string {
	let gameNameOnly = gameID;
	// strip variants from the gameName's end, only once
	gameVariants.some((variant) => {
		gameNameOnly = gameNameOnly.replace(new RegExp(`_${variant}$`), "");
		return gameID !== gameNameOnly;
	});
	return gameNameOnly;
}

/**
 * For running additional test/checks/assertions for development/debug purposes.
 * True in dev, false on prod.
 * Set in webpack.config.js
 */
export function shouldIncludeDevelopmentAssertions(): boolean {
	return typeof _INCLUDE_DEVELOPMENT_ASSERTIONS !== "undefined" && !!_INCLUDE_DEVELOPMENT_ASSERTIONS;
}